import { useState } from "react";
import _ from "lodash";
import ChevronDown from "../../assets/icons/ChevronDown";
import ChevronUp from "../../assets/icons/ChevronUp";

const SwitchFilter = ({ options, column }) => {
  const [Selected, setSelected] = useState(column.getFilterValue());
  const [OpenOptions, setOpenOptions] = useState(false);

  return (
    <div
      className={[
        "relative mt-4 text-sm font-normal flex justify-center cursor-pointer",
        OpenOptions ? "text-blue" : "text-gray-place_text",
      ].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
        setOpenOptions((prev) => !prev);
      }}
    >
      <div className={OpenOptions ? "text-blue" : "text-gray-place_text"}>
        Show:
      </div>
      <div className="text-blue pl-0.5">
        {_.findKey(options, (opt) => opt === Selected)}
      </div>
      <div className="relative bottom-px left-0.5">
        {OpenOptions ? <ChevronUp /> : <ChevronDown />}
      </div>
      {OpenOptions && (
        <>
          <div
            onClick={(e) => {
              setOpenOptions(false);
              e.stopPropagation();
            }}
            className="fixed top-0 right-0 left-0 bottom-0 z-10 cursor-default"
          ></div>
          <div className="absolute top-6 left-0 rounded-[4px] flex flex-col min-w-48 overflow-hidden z-20 text-white bg-gray-box_back">
            <div className="w-full px-6 py-3 text-start font-normal text-base text-gray-light_text">
              Show:
            </div>
            {Object.keys(options).map((item, i) => (
              <div
                key={i}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenOptions(false);
                  setSelected(options[item]);
                  column.setFilterValue(options[item]);
                }}
                className={[
                  "w-full px-6 py-3 text-start font-medium text-base",
                  Selected === options[item]
                    ? "bg-gray-box_back2"
                    : "bg-gray-box_back",
                ].join(" ")}
              >
                {item}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SwitchFilter;
